/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoVehicleBaseResponse as LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse } from '../../models/Limelight/Babylon/DataObjects/DTO/dto-vehicle-base-response';

export interface V3PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain$Params {
  applicationId: string;
}

export function v3PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain(http: HttpClient, rootUrl: string, params: V3PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain.PATH, 'get');
  if (params) {
    rb.path('applicationId', params.applicationId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LimelightBabylonDataObjectsDtoDtoVehicleBaseResponse>;
    })
  );
}

v3PublicApplicationVehicleApplicationIdVehicleInfoGet$Plain.PATH = '/v3/public/application/vehicle/{applicationId}/vehicle/info';
